import React from "react";

/**
 * Three ascending bars, used beside a player or team name to signal that the
 * row opens a vote breakdown modal.
 */
const BreakdownIcon = ({ className = 'w-3 h-3' }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4.5 19.5v-5.25m7.5 5.25V4.5m7.5 15v-9" />
  </svg>
);

export default BreakdownIcon;
